import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-material-dropdown',
  templateUrl: './material-dropdown.component.html',
  styleUrls: ['./../dropdown.component.scss']
})
export class MaterialDropdownComponent {
  @Input() options: Array<any>;
  activeTitle: string;
  isDropDown: boolean;

  @Output() readonly selectedOption: EventEmitter<any> = new EventEmitter<any>();

  onToggle(): void {
    this.isDropDown = !this.isDropDown;
  }

  onSelectOption(option: any): void {
    this.activeTitle = option.materialName + option.materialUnit;
    this.selectedOption.emit(option);
  }

  trackByFunction(index: number): number {
    return index;
  }
}
